import styled from 'styled-components';

export const StyledCustomerSelectedTable = styled.div`
  .ant-table-footer {
    display: none;
  }
`;
